import { array, InferType, number, object, ObjectSchema, string } from "yup";
import { models } from "types/api/viewModels.ts";

export const MOD_NOTES_MAX_LENGTH = 500;

const cqModSchema = object({
	id: string().nullable().required("Please select a modification type"),
	sku: string().nullable(),
	description: string().nullable(),
	value: number().nullable()
}) as unknown as ObjectSchema<models["CqModViewModel"]>;

const specialModSchema = object({
	id: string().nullable().required("Please select a special modification type"),
	sku: string().nullable(),
	description: string().nullable()
}) as unknown as ObjectSchema<models["SpecialModificationViewModel"]>;

export const CqModificationsFormSchema = object({
	cqCode: string().required("CQ code is required"),
	cqMods: array().of(cqModSchema).notRequired(),
	specialMods: array().of(specialModSchema).notRequired(),
	manualPercentAdjustment: string().notRequired(),
	manualFlatAdjustment: string().notRequired(),
	modNotes: string().max(MOD_NOTES_MAX_LENGTH).notRequired()
});

export type CQModificationsFormFields = InferType<typeof CqModificationsFormSchema>;
